import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "next-i18next";

import CloseIcon from "../icons/CloseIcon";
import UserSignin from "../forms/auth/login/Signin";
import UserSignup from "../forms/auth/register/Signup";

const AuthModal = ({ Context }) => {
  const [isRegister, setIsRegister] = useState(false);
  const {
    t,
    i18n: { language },
  } = useTranslation("common");
  useBodyScrollLock();
  const contentRef = useRef(null);
  useEffect(() => {
    const handleClick = (event) => {
      if (contentRef?.current?.contains?.(event?.target) === false) {
        Context?.dispatch({ type: "auth" });
      }
    };

    const addClickEventListener = () => {
      contentRef?.current?.parentNode?.addEventListener("click", handleClick);
    };

    const removeClickEventListener = () => {
      contentRef?.current?.parentNode?.removeEventListener(
        "click",
        handleClick
      );
    };

    if (contentRef.current.parentNode) {
      addClickEventListener();

      return () => {
        removeClickEventListener();
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={contentRef}
      className="w-11/12 sm:w-[640px] bg-white rounded-md max-h-[85vh] overflow-y-auto p-3"
    >
      <div className="flex items-center justify-between pb-2 border-b">
        <h2 className="font-bold sm:text-xl">
          {isRegister ? t("Register") : t("Login")}
        </h2>
        <CloseIcon
          onClick={() => Context?.dispatch({ type: "auth" })}
          className="cursor-pointer text-secondary-800 size-3 sm:size-4"
        />
      </div>
      <div className="grid grid-cols-2 my-4">
        <button
          onClick={() => setIsRegister(false)}
          className={`${
            !isRegister ? "bg-primary text-white" : "border text-secondary-900 "
          } font-semibold p-2 max-sm:text-sm ${
            language === "en" ? "rounded-l-lg" : "rounded-r-lg"
          }`}
        >
          {t("Login")}
        </button>
        <button
          onClick={() => setIsRegister(true)}
          className={`${
            isRegister ? "bg-primary text-white" : "border text-secondary-900 "
          } font-semibold p-2 max-sm:text-sm ${
            language === "en" ? "rounded-r-lg" : "rounded-l-lg"
          }`}
        >
          {t("Register")}
        </button>
      </div>
      {!isRegister ? (
        <UserSignin {...{ t, Context, language }} />
      ) : (
        <UserSignup {...{ t, language, setIsRegister }} />
      )}
    </div>
  );
};

export default AuthModal;
